import { gql } from '@apollo/client';

export default gql`
  query RenewalTaxPreflights($limit: Int, $onlyBlocked: Boolean) {
    renewalTaxPreflights(limit: $limit, onlyBlocked: $onlyBlocked) {
      subscriptionId
      subscriptionHexCode
      subscriptionName
      renewalAt
      partnerLocationId
      gateway
      required
      ready
      reason
      blockerCode
      blockerMessage
      blockedAt
      retryAt
    }
    taxjarCheckoutConfiguration {
      globalEnabled
      renewalEnabled
    }
  }
`;
